import { useState, useEffect, useRef, useMemo } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
	ClassicEditor,
	Autosave,
	Essentials,
	Paragraph,
	Autoformat,
	TextTransformation,
	LinkImage,
	Link,
	ImageBlock,
	ImageToolbar,
	BlockQuote,
	Bold,
	CloudServices,
	ImageUpload,
	ImageInsertViaUrl,
	AutoImage,
	Table,
	TableToolbar,
	FontBackgroundColor,
	FontColor,
	FontFamily,
	FontSize,
	Fullscreen,
	Heading,
	Highlight,
	HorizontalLine,
	ImageTextAlternative,
	ImageCaption,
	ImageStyle,
	Indent,
	IndentBlock,
	Code,
	ImageInline,
	Italic,
	AutoLink,
	List,
	ImageUtils,
	ImageEditing,
	Strikethrough,
	Style,
	GeneralHtmlSupport,
	Subscript,
	Superscript,
	TableCaption,
	Alignment,
	TodoList,
	Underline
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

import './App.css';

const LICENSE_KEY = 'GPL';

export default function RichTextEditor({ value, onChange }) {
  const editorContainerRef = useRef(null);
  const editorRef = useRef(null);

  const { editorConfig } = useMemo(() => ({
    editorConfig: {
      toolbar: {
  items: [
    'undo', 'redo', '|',
    'heading', 'style', '|',
    'bold', 'italic', 'underline', '|',
    'link', 'insertTable', 'insertImage', 'imageUpload', 'imageInsertViaUrl', '|',
    'bulletedList', 'numberedList', 'todoList', '|',
    'alignment', '|',
    'outdent', 'indent'
  ]
}
      ,
      plugins: [
        Alignment,
        Autoformat,
        AutoImage,
        AutoLink,
        Autosave,
        BlockQuote,
        Bold,
        CloudServices,
        Code,
        Essentials,
        FontBackgroundColor,
        FontColor,
        FontFamily,
        FontSize,
        Fullscreen,
        GeneralHtmlSupport,
        Heading,
        Highlight,
        HorizontalLine,
        ImageBlock,
        ImageCaption,
        ImageEditing,
        ImageInline,
        ImageInsertViaUrl,
        ImageStyle,
        ImageTextAlternative,
        ImageToolbar,
        ImageUpload,
        ImageUtils,
        Indent,
        IndentBlock,
        Italic,
        Link,
        LinkImage,
        List,
        Paragraph,
        Strikethrough,
        Style,
        Subscript,
        Superscript,
        Table,
        TableCaption,
        TableToolbar,
        TextTransformation,
        TodoList,
        Underline
      ],
      image: {
					toolbar: ['toggleImageCaption', 'imageTextAlternative', '|', 'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText']
				},
      fontFamily: { supportAllValues: true },
      fontSize: { options: [10, 12, 14, 'default', 18, 20, 22], supportAllValues: true },
      htmlSupport: {
  allow: [
    {
      name: 'img',
      attributes: true,
      styles: true,
      classes: true
    },
    {
      name: /.*/,
      attributes: true,
      styles: true,
      classes: true
    }
  ]
},
      licenseKey: LICENSE_KEY,
      placeholder: 'Type or paste your content here!',
      initialData: value // <-- use value from props
    }
  }), [value]);

  return (
            <CKEditor
              editor={ClassicEditor}
              config={editorConfig}
              data={value}
              onChange={(event, editor) => onChange?.(editor.getData())}
            />
  );
}
